
















































































import User from '@/types/User.interface'
import Vue, { PropType } from 'vue'
import UserLogo from '@/components/UserLogo.vue'
export default Vue.extend({
    components: { UserLogo },
    props: {
        assigned: {
            type: Number,
            default: null
        },
        broadcasts: {
            type: Number,
            default: null
        },
        comments: {
            type: Number,
            default: null
        },
        sent: {
            type: Number,
            default: null
        },
        average_response: {
            type: Number,
            default: null
        },
        average_handle_time: {
            type: Number,
            default: null
        },
        conversations_handled: {
            type: Number,
            default: null
        },
        user: {
            type: Object as PropType<User>,
            required: true
        }
    },
    methods: {
        routeUser(): void {
            //  Grab the current user's id
            const id = this.user.id

            //  Route to the teammates route with this id
            this.$router.push(`/teammates?user=${id}&edit=true`)
        }
    }
})
